"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constant = void 0;
exports.Constant = {
    Prompt: {
        VERSION_HEADER_NAME: 'x-prompt-version',
    },
};
//# sourceMappingURL=commonConstant.js.map